// components
import SvgIconStyle from '../../../components/SvgIconStyle';
import { PATH_DASHBOARD } from '../../../routes/paths';
import SummarizeIcon from '@mui/icons-material/Summarize';
import InsertChartIcon from '@mui/icons-material/InsertChart';
import AssignmentIcon from '@mui/icons-material/Assignment';
import SendIcon from '@mui/icons-material/Send';
import GroupIcon from '@mui/icons-material/Group';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import DnsIcon from '@mui/icons-material/Dns';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import ManageHistoryIcon from '@mui/icons-material/ManageHistory';
// ----------------------------------------------------------------------

const getIcon = (name) => (
  <SvgIconStyle
    src={`/assets/icons/navbar/${name}.svg`}
    sx={{ width: 1, height: 1 }}
  />
);

const ICONS = {
  user: getIcon('ic_user'),
  ecommerce: getIcon('ic_ecommerce'),
  analytics: getIcon('ic_analytics'),
  dashboard: getIcon('ic_dashboard'),
  reports: <SummarizeIcon />,
  chart: <InsertChartIcon />,
  management: <AssignmentIcon />,
  send: <SendIcon />,
  group: <GroupIcon />,
  userConfig: <ManageAccountsIcon />,
  machine: <DnsIcon />,
  phone: <LocalPhoneIcon />,
  history: <ManageHistoryIcon />,
};

const navConfig = [
  // TELEFONIA
  // ----------------------------------------------------------------------
  {
    subheader: '',
    shouldRender: PATH_DASHBOARD.telefonia.index.renderCondition,
    items: [
      {
        title: 'TELEFONÍA',
        icon: ICONS.phone,
        route: '/telefonia',
        shouldRender: PATH_DASHBOARD.telefonia.index.renderCondition,
        children: [
          {
            title: 'Reportes',
            icon: ICONS.management,
            route: '/telefonia',
            shouldRender:
              PATH_DASHBOARD.telefonia.reportes.index.renderCondition,
            children: [
              {
                title: 'Llamadas Realizadas',
                path: PATH_DASHBOARD.telefonia.reportes.llamadas_contestadas
                  .path,
                shouldRender:
                  PATH_DASHBOARD.telefonia.reportes.llamadas_contestadas
                    .renderCondition,
              },
              /* {
                title: 'Llamadas Fallidas',
                path: PATH_DASHBOARD.telefonia.reportes.llamadas_fallidas.path,
                shouldRender:
                  PATH_DASHBOARD.telefonia.reportes.llamadas_fallidas
                    .renderCondition,
              }, */
              {
                title: 'Llamadas Bloqueadas',
                path: PATH_DASHBOARD.telefonia.reportes.llamadas_bloqueadas
                  .path,
                shouldRender:
                  PATH_DASHBOARD.telefonia.reportes.llamadas_bloqueadas
                    .renderCondition,
              },
              {
                title: 'Resumen por Fecha',
                path: PATH_DASHBOARD.telefonia.reportes.resumen_por_fecha.path,
                shouldRender:
                  PATH_DASHBOARD.telefonia.reportes.resumen_por_fecha
                    .renderCondition,
              },
              {
                title: 'Resumen Prefijos',
                path: PATH_DASHBOARD.telefonia.reportes.resumen_prefijos.path,
                shouldRender:
                  PATH_DASHBOARD.telefonia.reportes.resumen_prefijos
                    .renderCondition,
              },
              {
                title: 'Resumen IP',
                path: PATH_DASHBOARD.telefonia.reportes.resumen_ip.path,
                shouldRender:
                  PATH_DASHBOARD.telefonia.reportes.resumen_ip.renderCondition,
              },
              {
                title: 'Informe de Bloqueos',
                path: PATH_DASHBOARD.telefonia.reportes.informe_bloqueos.path,
                shouldRender:
                  PATH_DASHBOARD.telefonia.reportes.informe_bloqueos
                    .renderCondition,
              },
              {
                title: 'CDR',
                path: PATH_DASHBOARD.telefonia.reportes.cdr.path,
                shouldRender:
                  PATH_DASHBOARD.telefonia.reportes.cdr.renderCondition,
              },
            ],
          },
          {
            title: 'Administración',
            route: '/telefonia',
            shouldRender:
              PATH_DASHBOARD.telefonia.administracion.index.renderCondition,
            icon: ICONS.management,
            children: [
              {
                title: 'CSV Bloqueos',
                path: PATH_DASHBOARD.telefonia.administracion.csv_bloqueos.path,
                shouldRender:
                  PATH_DASHBOARD.telefonia.administracion.csv_bloqueos
                    .renderCondition,
              },
              {
                title: 'N° Bloqueados',
                path: PATH_DASHBOARD.telefonia.administracion.numeros_bloqueados
                  .path,
                shouldRender:
                  PATH_DASHBOARD.telefonia.administracion.numeros_bloqueados
                    .renderCondition,
              },
              {
                title: 'Historial Bloqueos',
                path: PATH_DASHBOARD.telefonia.administracion.historial_bloqueos
                  .path,
                shouldRender:
                  PATH_DASHBOARD.telefonia.administracion.historial_bloqueos
                    .renderCondition,
              },
              {
                title: `ANI'S`,
                path: PATH_DASHBOARD.telefonia.administracion.ani.path,
                shouldRender:
                  PATH_DASHBOARD.telefonia.administracion.ani.renderCondition,
              },
            ],
          },
          {
            title: 'Gráficos',
            icon: ICONS.chart,
            route: '/telefonia',
            shouldRender:
              PATH_DASHBOARD.telefonia.graficos.index.renderCondition,
            children: [
              {
                title: 'Minutos Utilizados',
                path: PATH_DASHBOARD.telefonia.graficos.minutos_utilizados.path,
                shouldRender:
                  PATH_DASHBOARD.telefonia.graficos.minutos_utilizados
                    .renderCondition,
              },
            ],
          },
        ],
      },
    ],
  },
  // SMS
  // ----------------------------------------------------------------------
  {
    subheader: '',
    shouldRender: PATH_DASHBOARD.sms.index.renderCondition,
    items: [
      {
        title: 'SMS',
        route: '/sms/',
        shouldRender: PATH_DASHBOARD.sms.index.renderCondition,
        icon: ICONS.send,
        children: [
          {
            title: 'Envío Individual',
            icon: ICONS.send,
            path: PATH_DASHBOARD.sms.envio_individual.path,
            shouldRender: PATH_DASHBOARD.sms.envio_individual.renderCondition,
          },
          {
            title: 'Envío Masivo',
            icon: ICONS.send,
            path: PATH_DASHBOARD.sms.envio_masivo.path,
            shouldRender: PATH_DASHBOARD.sms.envio_masivo.renderCondition,
          },
          {
            title: 'Reportes',
            route: '/sms/',
            shouldRender: PATH_DASHBOARD.sms.reportes.index.renderCondition,
            icon: ICONS.management,
            children: [
              {
                title: 'Estados de Envios',
                path: PATH_DASHBOARD.sms.reportes.estado_de_envios.path,
                shouldRender:
                  PATH_DASHBOARD.sms.reportes.estado_de_envios.renderCondition,
              },
              {
                title: 'Resumen por Día',
                path: PATH_DASHBOARD.sms.reportes.resumen_por_dia.path,
                shouldRender:
                  PATH_DASHBOARD.sms.reportes.resumen_por_dia.renderCondition,
              },
              {
                title: 'Resumen de Enviados',
                path: PATH_DASHBOARD.sms.reportes.resumen_de_enviados.path,
                shouldRender:
                  PATH_DASHBOARD.sms.reportes.resumen_de_enviados
                    .renderCondition,
              },
              {
                title: 'SMS enviados',
                path: PATH_DASHBOARD.sms.reportes.sms_enviados.path,
                shouldRender:
                  PATH_DASHBOARD.sms.reportes.sms_enviados.renderCondition,
              },
              {
                title: 'SMS recibidos',
                path: PATH_DASHBOARD.sms.reportes.sms_recibidos.path,
                shouldRender:
                  PATH_DASHBOARD.sms.reportes.sms_recibidos.renderCondition,
              },
            ],
          },
        ],
      },
    ],
  },
  // SMS NG
  // ----------------------------------------------------------------------
  {
    subheader: '',
    shouldRender: PATH_DASHBOARD.sms_ng.index.renderCondition,
    items: [
      {
        title: 'SMS NG',
        route: '/sms-ng/',
        icon: ICONS.send,
        shouldRender: PATH_DASHBOARD.sms_ng.index.renderCondition,
        children: [
          {
            title: 'Envío Individual',
            icon: ICONS.send,
            path: PATH_DASHBOARD.sms_ng.envio_individual.path,
            shouldRender:
              PATH_DASHBOARD.sms_ng.envio_individual.renderCondition,
          },
          {
            title: 'Envío Masivo',
            icon: ICONS.send,
            path: PATH_DASHBOARD.sms_ng.envio_masivo.path,
            shouldRender: PATH_DASHBOARD.sms_ng.envio_masivo.renderCondition,
          },
          {
            title: 'API SMS',
            icon: ICONS.send,
            path: PATH_DASHBOARD.sms_ng.api_sms.path,
            shouldRender: PATH_DASHBOARD.sms_ng.api_sms.renderCondition,
          },
          {
            title: 'Estado Campaña',
            icon: ICONS.send,
            path: PATH_DASHBOARD.sms_ng.estado_campana.path,
            shouldRender: PATH_DASHBOARD.sms_ng.estado_campana.renderCondition,
          },
          {
            title: 'Reportes',
            route: '/sms-ng/',
            icon: ICONS.management,
            shouldRender: PATH_DASHBOARD.sms_ng.reportes.index.renderCondition,
            children: [
              {
                title: 'Estados Salientes',
                path: PATH_DASHBOARD.sms_ng.reportes.estados_salientes.path,
                shouldRender:
                  PATH_DASHBOARD.sms_ng.reportes.estados_salientes
                    .renderCondition,
              },
              {
                title: 'SMS Asociados',
                path: PATH_DASHBOARD.sms_ng.reportes.sms_asociados.path,
                shouldRender:
                  PATH_DASHBOARD.sms_ng.reportes.sms_asociados.renderCondition,
              },
              {
                title: 'SMS Salientes',
                path: PATH_DASHBOARD.sms_ng.reportes.sms_salientes.path,
                shouldRender:
                  PATH_DASHBOARD.sms_ng.reportes.sms_salientes.renderCondition,
              },
              {
                title: 'SMS Entrantes',
                path: PATH_DASHBOARD.sms_ng.reportes.sms_entrantes.path,
                shouldRender:
                  PATH_DASHBOARD.sms_ng.reportes.sms_entrantes.renderCondition,
              },
              {
                title: 'Resumen por Fecha',
                path: PATH_DASHBOARD.sms_ng.reportes.resumen_por_fecha.path,
                shouldRender:
                  PATH_DASHBOARD.sms_ng.reportes.resumen_por_fecha
                    .renderCondition,
              },
              {
                title: 'Exportar Salientes',
                path: PATH_DASHBOARD.sms_ng.reportes.exportar_salientes.path,
                shouldRender:
                  PATH_DASHBOARD.sms_ng.reportes.exportar_salientes
                    .renderCondition,
              },
              {
                title: 'Exportar Asociados',
                path: PATH_DASHBOARD.sms_ng.reportes.exportar_asociados.path,
                shouldRender:
                  PATH_DASHBOARD.sms_ng.reportes.exportar_asociados
                    .renderCondition,
              },
              {
                title: 'Exportar Entrantes',
                path: PATH_DASHBOARD.sms_ng.reportes.exportar_entrantes.path,
                shouldRender:
                  PATH_DASHBOARD.sms_ng.reportes.exportar_entrantes
                    .renderCondition,
              },
            ],
          },
        ],
      },
    ],
  },
  //  API SMS NG
  // ----------------------------------------------------------------------
  /* {
    subheader: 'API SMS NG',
    shouldRender: PATH_DASHBOARD.api_sms_ng.index.renderCondition,
    items: [
      {
        title: 'Simple',
        icon: ICONS.send,
        path: PATH_DASHBOARD.api_sms_ng.simple.path,
        shouldRender: PATH_DASHBOARD.api_sms_ng.simple.renderCondition,
      },
    ],
  }, */
  // TICKETS
  // ----------------------------------------------------------------------
  {
    subheader: '',
    shouldRender: PATH_DASHBOARD.tickets.index.renderCondition,
    items: [
      {
        title: 'TICKETS',
        route: '/tickets/',
        icon: ICONS.management,
        shouldRender: PATH_DASHBOARD.tickets.index.renderCondition,
        children: [
          {
            title: 'Requerimientos',
            icon: ICONS.management,
            path: PATH_DASHBOARD.tickets.requerimientos.path,
            shouldRender: PATH_DASHBOARD.tickets.requerimientos.renderCondition,
          },
          {
            title: 'Incidentes',
            icon: ICONS.management,
            path: PATH_DASHBOARD.tickets.incidentes.path,
            shouldRender: PATH_DASHBOARD.tickets.incidentes.renderCondition,
          },
        ],
      },
    ],
  },
  // Máquinas Virtuales
  // ----------------------------------------------------------------------
  {
    subheader: '',
    shouldRender: PATH_DASHBOARD.maquinas_virtuales.index.renderCondition,
    items: [
      {
        title: 'MÁQUINAS VIRTUALES',
        route: '/maquinas-virtuales/',
        icon: ICONS.machine,
        shouldRender: PATH_DASHBOARD.maquinas_virtuales.index.renderCondition,
        children: [
          {
            title: 'Listar',
            icon: ICONS.management,
            path: PATH_DASHBOARD.maquinas_virtuales.listar.path,
            shouldRender:
              PATH_DASHBOARD.maquinas_virtuales.listar.renderCondition,
          },
        ],
      },
    ],
  },
  //Logs
  // ----------------------------------------------------------------------

  {
    subheader: '',
    shouldRender: PATH_DASHBOARD.logs.index.renderCondition,
    items: [
      {
        title: 'HISTORIAL',
        route: '/logs/',
        icon: ICONS.history,
        shouldRender: PATH_DASHBOARD.logs.index.renderCondition,
        children: [
          {
            title: 'Detalle',
            icon: ICONS.group,
            path: PATH_DASHBOARD.logs.detalle.path,
            shouldRender: PATH_DASHBOARD.logs.detalle.renderCondition,
          },
        ],
      },
    ],
  },
  // Configuraciones
  // ----------------------------------------------------------------------
  {
    shouldRender: PATH_DASHBOARD.configuraciones.index.renderCondition,
    items: [
      {
        title: 'CONFIGURACIONES',
        route: '/configuraciones/',
        icon: ICONS.userConfig,
        shouldRender: PATH_DASHBOARD.configuraciones.usuarios.renderCondition,
        children: [
          {
            title: 'Usuarios',
            icon: ICONS.group,
            path: PATH_DASHBOARD.configuraciones.usuarios.path,
            shouldRender:
              PATH_DASHBOARD.configuraciones.usuarios.renderCondition,
          },
        ],
      },
    ],
  },
];

export default navConfig;
